import { Accordion } from "react-bootstrap";
import { useCallback, useState, Fragment } from "react";
import { useFormsConfig } from "../deployment/forms/Context";

const GuidedExperience = ({ metadata }) => {
    const [, setHighlightedItem] = useState();
    const { logAmplitudeEvent, experienceMode } = useFormsConfig();
    const [activeKeysNested, setActiveKeysNested] = useState(metadata[0].subItems.map(item => item.eventKey));

    const setHighlight = useCallback((id) => {
        const el = document.getElementById(id);

        logAmplitudeEvent({
            eventType: "triggerHighlight",
            eventProperties: {
                highlightId: id
            }
        });

        if (!el) {
            return;
        }
        setHighlightedItem((prev) => {
            if (prev) {
                prev.classList.remove("guidedHighlight");
            }
            return el;
        });
        const currentOnClick = el.onclick;
        el.onclick = function () {
            if (currentOnClick) {
                currentOnClick();
            }
            el.classList.remove("guidedHighlight");
        }

        el.classList.add("guidedHighlight");
        setTimeout(() => { el.classList.remove("guidedHighlight") }, 10000);

        el.scrollIntoView({ behaviour: 'smooth', block: 'nearest' });
    }, [logAmplitudeEvent]);

    const handleSelect = useCallback((params) => {
        logAmplitudeEvent({
            eventType: "triggerGuideAccordion",
            eventProperties: {
                params: params ? params : 'closed accordion',
                experienceMode
            }
        });
        const allSubItemEventKeys = [];
        metadata.forEach(item => {
            item.subItems.forEach(subItem => {
                allSubItemEventKeys.push(subItem.eventKey);
            });
        });
        setActiveKeysNested(allSubItemEventKeys);
    }, [metadata, experienceMode, logAmplitudeEvent]);

    const renderVariableItem = useCallback((variableItem) => {
        if (!variableItem) {
            return '';
        }
        switch (variableItem.type) {
            case 'bold': return <strong>{variableItem.text}</strong>
            case 'italic': return <em className='text-primary'>{variableItem.text}</em>
            case 'hyperlink': return <a href={variableItem.href} target="_blank" rel="noreferrer" onClick={() => {
                logAmplitudeEvent({
                    eventType: "triggerHyperlink", eventProperties: { hyperlink: variableItem.href }
                })
            }}> {variableItem.text}</a >
            case 'highlight': return <button
                type="button"
                className={`${variableItem.showLinkInModes.includes(experienceMode) ? 'template-examples-button-link' : 'template-examples-button-disabled-link'}`}
                onClick={() => { setHighlight(variableItem.itemId); return false; }}>
                {variableItem.text}
            </button>
            default: return '';
        }
    }, [experienceMode, setHighlight, logAmplitudeEvent]);

    const getParagraphWithVariables = useCallback(({ text, variables, className, key }) => {
        const textArr = [];
        const textSplit = text.split('$VS{');

        textSplit.forEach(part => {
            const subParts = part.split('}VE$');
            if (subParts.length === 1) {
                textArr.push(part);
            }

            if (subParts.length === 2) {
                textArr.push(renderVariableItem(variables.find(variable => variable.id === subParts[0])));
                textArr.push(subParts[1]);
            }
        });

        return <p className={className} key={key}>
            {textArr.map((part, index) => <Fragment key={index}>{part}</Fragment>)}
        </p>
    }, [renderVariableItem]);


    if (!metadata) {
        return null;
    }

    return <div className="flex-grow-1 overflow-y-auto padded-scrollbar">
        <Accordion defaultActiveKey={["item1"]} className="template-examples" onSelect={handleSelect}>
            {metadata.map((item) =>
                <Accordion.Item eventKey={item.eventKey} key={item.eventKey}>
                    <Accordion.Button className="template-examples-button">
                        {item.header}
                    </Accordion.Button>
                    <Accordion.Body className="template-examples-body">
                        {item.texts.map((text, index) =>
                            getParagraphWithVariables({ key: index, text, variables: item.variables, className: "template-examples-p" })
                        )}

                        <Accordion activeKey={activeKeysNested} flush alwaysOpen onSelect={setActiveKeysNested}>
                            {item.subItems.map((subItem) =>
                                <Accordion.Item eventKey={subItem.eventKey} key={subItem.eventKey} className="template-examples-nested-item">
                                    <Accordion.Button className="template-examples-nested-button">
                                        {subItem.header}
                                    </Accordion.Button>

                                    <Accordion.Body className="template-examples-nested-body">
                                        {getParagraphWithVariables({ ...subItem, className: "template-examples-nested-p" })}
                                    </Accordion.Body>

                                </Accordion.Item>)}
                        </Accordion>

                    </Accordion.Body>
                </Accordion.Item>)}
        </Accordion>
    </div >
}

export default GuidedExperience;